import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Card,
  CardContent,
  Button,
  Typography
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  School as SchoolIcon,
  AccountCircle as AccountCircleIcon
} from '@mui/icons-material';

function CheckoutSuccess() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        py: 4
      }}
    >
      <Container maxWidth="sm">
        <Card elevation={3}>
          <CardContent sx={{ textAlign: 'center', py: 6, px: 4 }}>
            <CheckCircleIcon
              sx={{
                fontSize: 120,
                color: 'success.main',
                mb: 3
              }}
            />
            <Typography variant="h3" component="h1" sx={{ fontWeight: 700, mb: 2 }}>
              Payment Successful!
            </Typography>
            <Typography variant="h6" color="text.secondary" sx={{ mb: 1 }}>
              Thank you for your enrollment.
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
              Your payment has been processed successfully. You will receive a confirmation email shortly.
            </Typography>

            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                gap: 2,
                justifyContent: 'center',
                mt: 4
              }}
            >
              <Button
                component={RouterLink}
                to="/programs"
                variant="contained"
                size="large"
                startIcon={<SchoolIcon />}
                sx={{ px: 4 }}
              >
                Browse More Programs
              </Button>
              <Button
                component={RouterLink}
                to="/my-account"
                variant="outlined"
                size="large"
                startIcon={<AccountCircleIcon />}
                sx={{ px: 4 }}
              >
                Go to My Account
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Container>
    </Box>
  );
}

export default CheckoutSuccess;
